<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="info.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="500px"
  >
    <div>
      <el-radio-group class="radioGroup" v-model="value">
        <el-radio :label="1">全部用户</el-radio>
        <el-radio class="m-t-40" :label="2">指定用户</el-radio>
      </el-radio-group>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="onComfrim()" title="确定"></butn>
    </div>
    
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { ticketUserUpdateLimitType } from "@/api/resourceService";

export default {
  components: { butn },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          show: false,
        };
      },
    },
  },
  data() {
    return {
      curdTitle: "预约范围设置",
      value: 1,
    };
  },
  created() {
    this.value = this.info.limitType || 1;
  },
  methods: {
    onComfrim() {
      this.$confirm('确认修改预约范围设置吗？', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          ticketUserUpdateLimitType({
            ticketDetailId: this.info.uuid,
            ticketId: this.info.ticketId,
            limitType: this.value,
          }).then(res => {
            if (res && res.code == 0) {
              this.$emit("closeDialog", true, this.value);
            }
          })
        })
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.radioGroup {
  display: flex;
  flex-direction: column;
  .m-t-40 {
    margin-top: 40px;
  }
}
</style>
